import { render, staticRenderFns } from "./StudioPodcastCard.vue?vue&type=template&id=0a4226e4&scoped=true&"
import script from "./StudioPodcastCard.vue?vue&type=script&lang=js&"
export * from "./StudioPodcastCard.vue?vue&type=script&lang=js&"
import style0 from "./StudioPodcastCard.vue?vue&type=style&index=0&id=0a4226e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4226e4",
  null
  
)

export default component.exports